<template>
  <div class="flex items-center" :title="cart.CartName">
    <icon-fgt v-if="primary" :name="primary" class="h-8" />
    <icon-fgt v-if="secondary" :name="secondary" class="h-6" />
  </div>
</template>

<script>
export default {
  props: {
    cart: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      primary: null,
      secondary: null,
    };
  },
  computed: {},
  components: {},
  methods: {},
  created() {

    if ([2, 10, 17, 22].includes(parseInt(this.cart.ID)))
      this.primary = "fgt-logo";
    if ([1, 11, 14, 16, 23, 24, 25, 26, 27, 30].includes(parseInt(this.cart.ID)))
      this.primary = "bb-logo";
    if ([12, 18, 19, 20].includes(parseInt(this.cart.ID)))
      this.primary = "byf";
    if ([21].includes(parseInt(this.cart.ID)))
      this.primary = "nmn";
    if ([31].includes(parseInt(this.cart.ID)))
      this.primary = "pt";
    if ([32].includes(parseInt(this.cart.ID)))
      this.primary = "trees";

    if (this.cart.CartName.toLowerCase().includes("amazon")) this.secondary = "amazon";
    if (this.cart.CartName.toLowerCase().includes("amazon prime")) this.secondary = "amazon-prime";
    if (this.cart.CartName.toLowerCase().includes("ebay")) this.secondary = "ebay";
    if (this.cart.CartName.toLowerCase().includes("etsy")) this.secondary = "etsy";
    if (this.cart.CartName.toLowerCase().includes("home depot")) this.secondary = "home-depot";
    if (this.cart.CartName.toLowerCase().includes("lowes")) this.secondary = "lowes";
    if (this.cart.CartName.toLowerCase().includes("qvc")) this.secondary = "qvc";
    if (this.cart.CartName.toLowerCase().includes("walmart")) this.secondary = "walmart";
    if (this.cart.CartName.toLowerCase().includes("jet")) this.secondary = "jet";

  },
};
</script>
